<template>
  <div class="main-page-wrapper">
    <SliderComponent/>
    <static-block-component page="home" position="top"/>
    <div v-if="selectedParticipant" class="d-flex my-2 mx-4">
      <image-component
          class="filter-image"
          v-if="selectedParticipant.custom_icon"
          :path="selectedParticipant.custom_icon"
      />
      <h3 class="my-auto ml-2">{{ selectedParticipant.name }}</h3>
    </div>
    <div class="container-fluid home">
      <static-block-component
          page="home"
          position="middle"
      />

      <adsense-block adClient="ca-pub-9623662250069302" adSlot="8527483633"/>

      <section class="events max-content-wrapper">
        <event-main-section
            :categories="sportCategoryId"
            v-bind:[eventCarouselBindProps]="participantId"
            :can-process-request="allowProcessingEventRequest"
        />
      </section>
      <template v-if="featuredContentData">
        <div
          v-if="featuresContent.length"
          class="features-carousel-wrapper"
        >
          <div class="max-content-wrapper section_event w-100">
            <carousel-component
              v-if="!mobileView"
              :scrolled-quantity="2"
              :item-data="featuresContent"
              :max-per-line="featuresContent.length"
              :min-item-width="280"
              :max-item-width="380"
              :integer-items-quantity="false"
              class="features-carousel d-flex flex-column gap-1"
            >
              <template v-slot:before>
                <div
                  class="w-100 d-flex justify-content-between flex-grow-1
              align-items-center mr-3 carousel-title"
                >
                  <span> {{$t(featuredContentData.title)}} </span>
                </div>
              </template>
              <template v-slot:default="{ props }">
                <vod-grid-item
                  :key="props.id"
                  :vod-info="props"
                  class="features-item px-2 py-2"
                />
              </template>
            </carousel-component>
            <template v-else>
              <vod-grid-item
                v-for="vod in featuresContent.slice(0, featuredContentData.maxMobileCards)"
                :key="vod.id"
                :vod-info="vod"
                class="features-item ml-2 mr-2"
              />
            </template>
          </div>
        </div>
      </template>
      <div class="school_carousel max-content-wrapper" v-if="teamCarouselData.length">
        <carousel-component
          :scrolled-quantity="2"
          :item-data="teamCarouselData"
          :max-per-line="teamCarouselData.length"
          :min-item-width="90"
          :max-item-width="130"
          :integer-items-quantity="false"
          class="schools"
        >
          <template v-slot:before>
            <div
              class="w-100 d-flex justify-content-between flex-grow-1
              align-items-center mr-3 carousel-title"
            >
              <span> {{$t(participantTitle)}} </span>
            </div>
          </template>
          <template v-slot:default="{ props }">
            <app-link
                :key="`${props.id}`"
                :to="props.url"
                class="carousel_link mx-2"
            >
              <image-component :path="props.custom_icon"/>
              <p>
                {{ props.name }}
              </p>
            </app-link>
          </template>
        </carousel-component>
      </div>
      <div
        v-if="vodRailNeed"
        class="school_carousel max-content-wrapper"
        id="vod_media"
      >
        <vod-rail/>
      </div>
    </div>
    <packages-nodes v-if="!isGeoBlocked" class="packages_section pb-4 max-content-wrapper">
      <template v-slot:title>
        <h2 class="w-100 d-flex justify-content-between flex-grow-1 align-items-center mr-3
          carousel-title"
        >
          {{ $t('Passes') }}
        </h2>
      </template>
    </packages-nodes>
    <adsense-block adClient="ca-pub-9623662250069302" adSlot="8691135167"/>
    <static-block-component
        page="home"
        position="bottom"
    />
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import SliderComponent from '@/league/components/main/SliderComponent';
import StaticBlockComponent from '@/components/StaticBlockComponent';
import EventMainSection from '@/league/components/main/EventMainSection';
import {URL_QUERIES} from '@/const';
import CarouselComponent from '@/components/base-components/CarouselComponent';
import AppLink from '@/components/base-components/AppLink';
import ImageComponent from '@/components/base-components/ImageComponent';
import AdsenseBlock from '@/components/base-components/adsense/AdsenseBlock.vue';
import PackagesNodes from '@/components/base-components/Packages/Nodes.vue';
import {getNestedValue} from '@/utils/helpers';
import {GET_VOD_ITEMS} from '@/store/actionTypes';
import VodGridItem from '@/league/components/vod/VodGridItem.vue';
import VodRail from '@/league/components/vod/VodRail.vue';

export default {
  name: 'HomeScreen',
  components: {
    VodRail,
    VodGridItem,
    PackagesNodes,
    ImageComponent,
    AppLink,
    CarouselComponent,
    EventMainSection,
    SliderComponent,
    StaticBlockComponent,
    AdsenseBlock,
  },
  inject: {
    watchFoViewChanges: 'watchFoViewChanges',
  },
  data() {
    return {
      categoryQuery: this.$route.query?.[URL_QUERIES.category],
      participantQuery: this.$route.query?.[
        URL_QUERIES[this.$projectSettings?.home?.teamCarousel?.urlQuery]
      ],
      featuresContent: [],
      mobileView: false,
    };
  },
  computed: {
    ...mapState({
      categories: (state) => Object.values(state.event.eventCategoriesById),
      groupMenu: (state) => state.channel.groupMenu,
      channelSettings: (state) => state.channel.settings,
      isGeoBlocked: (state) => state.auth?.is_geo_blocked,
    }),
    eventCarouselBindProps() {
      return this.$projectSettings?.home?.eventsCarousel?.bindProps || 'groups';
    },
    vodRailNeed() {
      return this.$projectSettings?.home?.vodRailNeed;
    },
    featuredContentData() {
      return this.$projectSettings?.home?.featuredCarousel;
    },
    teamCarouselData() {
      const str = this.$projectSettings?.home?.teamCarousel?.data || 'channel.groupMenu';
      return getNestedValue(str, this.$store.state);
    },
    participantTitle() {
      return this.$projectSettings?.home?.teamCarousel?.title || 'Teams';
    },
    sportCategoryId() {
      if (!this.categoryQuery) return;
      const id = this.categories?.find(({
        name,
        alias,
      }) => {
        return (
          alias?.toLowerCase() === this.categoryQuery.toLowerCase() ||
            name?.toLowerCase() === this.categoryQuery.toLowerCase()
        );
      })?.id;
      if (id) {
        return [id];
      }
      if (this.categories.length) {
        this.$router.replace({
          ...this.$route,
          query: {},
        });
      }
      return undefined;
    },
    participantId() {
      if (!this.participantQuery) return;
      const groupId = this.teamCarouselData.find((group) => {
        return (
          group.alias.toLowerCase() === this.participantQuery.toLowerCase() ||
            group.name.toLowerCase() === this.participantQuery.toLowerCase()
        );
      })?.id;
      if (groupId) return [groupId];

      if (this.teamCarouselData.length) {
        this.$router.replace({
          ...this.$route,
          query: {},
        });
      }
      return undefined;
    },
    selectedParticipant() {
      if (!this.participantQuery) return '';
      return this.teamCarouselData?.find((group) => {
        return (
          group.alias.toLowerCase() === this.participantQuery.toLowerCase() ||
            group.name.toLowerCase() === this.participantQuery.toLowerCase()
        );
      });
    },
    allowProcessingEventRequest() {
      const allowSportRequest = this.categoryQuery ?
          Boolean(this.sportCategoryId) :
          true;
      const allowTeamRequest = this.participantQuery ?
          Boolean(this.participantId) :
          true;
      return allowSportRequest && allowTeamRequest;
    },
  },
  watch: {
    $route(to) {
      this.categoryQuery = to.query?.[URL_QUERIES.category];
      this.participantQuery = to.query?.[
        URL_QUERIES[this.$projectSettings?.home?.teamCarousel?.urlQuery] ||
        URL_QUERIES.participantGroup
      ];
    },
  },
  methods: {
    ...mapActions({
      getFeatures: GET_VOD_ITEMS,
    }),
    getFeaturedContent() {
      if (
        Boolean(this.featuredContentData) &&
        Boolean(Number(this.channelSettings?.archive?.vod_guest_access))
      ) {
        this.getFeatures({
          is_featured: 1,
          limit: 12,
        }).then(({data = []}) => {
          this.featuresContent = data;
        }).catch(() => {
          this.featuresContent = [];
        });
      }
    },
  },
  mounted() {
    const unsubscribeCb = this.watchFoViewChanges((isMobile) => {
      this.mobileView = isMobile;
    });
    this.$once('hook:beforeDestroy', unsubscribeCb);
    this.getFeaturedContent();
  },
  metaInfo() {
    const titleParts = [];
    this.selectedParticipant?.name && titleParts.push(this.selectedParticipant.name.toUpperCase());
    titleParts.push(this.$route.meta.title);
    return {
      title: titleParts.join(' '),
      titleTemplate: this.channelSettings ? '%s - ' + this.channelSettings.title : '%s - Visaic',
    };
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/css/mixins";
#app .main-page-wrapper {
  background-color: var(--settings-body-main-color);
  font-style: normal;
}

.filter-image {
  height: 4rem;
}

.home {
  padding: 0;
}

.event-list {
  padding: 0 1rem;
}

.events {
  background-color: var(--settings-body-background);
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin: 0 auto;
}

.section_event {
  padding: 1rem var(--padding-y-mobile);
}

.school_carousel {
  max-width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  font-style: normal;
  padding: 5rem var(--padding-y-mobile) 0;
  @include media-min(max-container) {
    max-width: 1920px;
  }

  .carousel {
    max-width: 100vw;
    width: 100%;
    @include media-max(sm) {
      max-width: 100%;
    }
  }
}

.packages_section {
  margin-top: 5rem;
  padding: 0 var(--padding-y-mobile);
}
</style>

<style lang="scss">
@import "src/assets/css/mixins";

a.more-button {
  color: var(--settings-body-text-color);
  transition: all 0.3s;
  padding: 0.5rem 1.2rem;
  text-decoration: none;
  font-size: 1.3rem;
  font-weight: 500;
}

a.more-button__black {
  color: var(--text-secondary);
  font-weight: 600;
  font-size: 1.2rem;
  text-decoration: none;
  text-transform: uppercase;
  transition: all 0.3s;

  div {
    background: var(--button-primary-background);
    margin: 1rem;
    border-radius: 0.3rem;
    box-shadow: var(--card-shadow);
    padding: 0.5rem;
  }
}

.carousel_items {
  .card {
    margin: 0.5rem;
  }
}

.schools {
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .carousel_navigation {
    margin-left: auto;
  }
}

.carousel-title {
  font-size: 1.5rem;
  font-weight: 900;
}

.carousel-button {
  font-weight: 700;
  font-size: 1.2rem;
  color: var(--settings-body-text-color);

  &:hover {
    color: var(--settings-body-text-color);
    text-decoration: none;
  }
}

.carousel_link {
  border-radius: .2rem;
  box-shadow: 0 0 3px var(--settings-body-text-color-50);
  background-color: var(--settings-team-card-background-color);
  padding: 0.5rem 0.5rem 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-transform: none;
  font-weight: var(--settings-team-card-font-weight);
  font-family: var(--settings-team-card-font-family), sans-serif;
  color: var(--settings-team-card-text-color);
  &:hover {
    color: var(--settings-team-card-text-color);
    text-decoration: none;
    p {
      transform: translateY(0);
      opacity: 1;
    }
    img {
      transform: translateY(0);
    }
  }
  @include media-max(sm) {
    margin: .7rem;
  }
  p {
    margin: 0;
    font-size: 0.8rem;
    transition: transform .2s linear, opacity .2s 0.1s linear;
    will-change: transform, opacity;
    @include media-min(lg) {
      transform: translateY(3rem);
      opacity: 0;
    }
  }
  img {
    width: 80%;
    margin: 0 auto;
    object-fit: contain;
    transition: transform .2s linear;
    will-change: transform;
    @include media-min(lg) {
      transform: translateY(1.5rem);
    }
    @include media-max(lg) {
      padding: 0.2rem;
    }
  }
}
.features-carousel,
.features-item {
  --vod-title-color: var(--settings-event-card-text-color);
  --vod-subtitle-color: var(--settings-event-card-text-color);
}
</style>
